import { initializeErrorReporting } from '@eventbrite/error-reporting';
import React from 'react';
import { render } from 'react-dom';
import { initializeStatsigSdk } from './actions/statsig';
import App from './app';
import {
    initDimensionsFromState,
    trackInitialPageView,
} from '@eventbrite/site-analytics';
import GenericErrorMessage from './components/errorNotification/GenericErrorMessage';
import logger from '@eventbrite/client-logger';
import {
    getLocaleOverride,
    setupAsync,
    getParentLocale,
} from '@eventbrite/i18n';
import { initDatadogRUM } from './initDatadogRUM';

const rootElement = document.getElementById('root');
const appContext = window.__SERVER_DATA__;
const isProd = (domain = {}) => domain.includes('eventbrite');

const main = async () => {
    if (!appContext) {
        throw new Error('appContext is missing');
    }
    if (!rootElement) {
        throw new Error('rootElement is null');
    }

    // __LOCALS__ is defined only when running checkout using `bolt dev`. In this situation __SERVER_DATA__ does not have app_name nor app_version
    const appName =
        appContext.app_name ??
        window.__LOCALS__.application.name
            .replace('@eventbrite/', '')
            .replace('@eventbrite/', '');
    const appVersion = appContext.app_version;

    const parentLocale = getParentLocale(
        getLocaleOverride() || appContext.env.localeInfo.locale,
    );

    try {
        initializeErrorReporting();
        if (parentLocale !== 'en_US') {
            await setupAsync({
                parentLocale,
                translations:
                    /* webpackChunkName: "checkout-i18n-translation" */ import(
                        `./i18n/translations/${parentLocale}.json`
                    ),
            });
        }
        await initializeStatsigSdk(appContext);
    } finally {
        render(
            <App {...appContext} appName={appName} appVersion={appVersion} />,
            rootElement,
        );

        initDimensionsFromState(appContext);
        trackInitialPageView(appContext.gaSettings);

        if (isProd(appContext.env.ebDomain)) {
            initDatadogRUM({
                app: { name: appName, version: appVersion },
            });
        }
    }
};

try {
    main();
} catch (error) {
    logger.error('checkoutWidget main error:', {
        error: error.message ? error.message : error,
        appContext,
    });
    if (rootElement) {
        try {
            render(<GenericErrorMessage />, rootElement);
        } catch (e) {
            logger.error('GenericErrorMessage error:', {
                error: e,
            });
        }
    }
}
